import type { ProjectMeta } from '../types';
import { STATUS_OPTIONS } from '../types';

interface Props {
  value: ProjectMeta;
  onChange: (next: ProjectMeta) => void;
}

export function ProjectMetaForm({ value, onChange }: Props) {
  const update = <K extends keyof ProjectMeta>(key: K, v: ProjectMeta[K]) => {
    onChange({ ...value, [key]: v });
  };

  return (
    <div className="rounded-lg border border-tb-border bg-tb-surface p-4 shadow-sm">
      <h2 className="text-sm font-semibold text-tb-text mb-3">案件資訊</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        <Field label="目前狀態">
          <select
            className="input"
            value={value.status}
            onChange={e => update('status', e.target.value as ProjectMeta['status'])}
          >
            {STATUS_OPTIONS.map(s => <option key={s} value={s}>{s}</option>)}
          </select>
        </Field>
        <Field label="案號"><input className="input" value={value.caseNo} onChange={e => update('caseNo', e.target.value)} placeholder="A115017" /></Field>
        <Field label="合約金額"><input className="input" value={value.contractAmount} onChange={e => update('contractAmount', e.target.value)} placeholder="$ 2,360,000" /></Field>
        <Field label="地址 / 案件名稱" span={3}>
          <textarea
            className="input min-h-[2.5rem]"
            value={value.address}
            onChange={e => update('address', e.target.value)}
            rows={2}
            placeholder="260316新莊西盛街丁先生&#10;新北市新莊區國西盛街369巷7號5樓"
          />
        </Field>
        <Field label="設計"><input className="input" value={value.designer} onChange={e => update('designer', e.target.value)} placeholder="外-育泰" /></Field>
        <Field label="工務"><input className="input" value={value.foreman} onChange={e => update('foreman', e.target.value)} placeholder="小白" /></Field>
        <Field label="協調延宕天數"><input className="input" value={value.delayDays} onChange={e => update('delayDays', e.target.value)} placeholder="30天" /></Field>
        <Field label="開工日">
          <input type="date" className="input" value={value.startDate} onChange={e => update('startDate', e.target.value)} />
        </Field>
        <Field label="預計完工日">
          <input type="date" className="input" value={value.endDate} onChange={e => update('endDate', e.target.value)} />
        </Field>
        <Field label="目前進度 / 備註">
          <input className="input" value={value.notes} onChange={e => update('notes', e.target.value)} placeholder="例：油漆 / 24 天 / 還沒開工" />
        </Field>
      </div>
    </div>
  );
}

function Field({ label, children, span = 1 }: { label: string; children: React.ReactNode; span?: 1 | 2 | 3 }) {
  const cls = span === 3 ? 'md:col-span-3' : span === 2 ? 'md:col-span-2' : '';
  return (
    <label className={`flex flex-col gap-1 ${cls}`}>
      <span className="text-xs font-medium text-tb-text2">{label}</span>
      {children}
    </label>
  );
}
